import React, { useState } from "react";
import axios from "axios";
import LoginForm from "./LoginForm";

function LoginFormWrapper(props) {  
  const [disabled, setDisabled] = useState(false);

  /* Create object representing the metadata */
  const createPayload = inputs => {
    return {
      identityscheme: "manualid", // Same for every user
      nameidentifier: props.user.sub.split("|")[1], // Can be anything chosen by Cerberus, we're using the auth0 username
      country: inputs.issuingCountry,
      givenname: inputs.firstName,
      surname: inputs.surname,
      passportData: {
        passportNumber: inputs.passportNumber,
        personalNumber: inputs.personalNumber,
        dateOfBirth:
          inputs.dobYear + "-" + inputs.dobMonth + "-" + inputs.dobDay,
        passportExpiry:
          inputs.doeYear + "-" + inputs.doeMonth + "-" + inputs.doeDay
      },
      password: inputs.password1
    };
  };

  const handleSubmit = values => {
    setDisabled(true)
    /* Post Metadata to Auth0 db */
    let url = '/api/auth0/addMetaData/' + props.user.sub
    let body = createPayload(values)
    return axios.post(url, body).then(function(res) {
      console.log("user with metadata", res.body);
      /* Reload the page to fetch the updated verification level */
      window.location.reload(true);
    }).catch(error => {
      let errorMsg
      if (error.response !== undefined) {
        console.log(error.response)
        errorMsg = "Error " + error.response.status + " accessing " + error.response.config.url
      } else {
        errorMsg = "Error in getting user data"
      }
      props.setError(true);
      props.setErrorMessage(errorMsg);
      setDisabled(false)
    });
  };

  return (
    <div className="form">
      <LoginForm disabled={disabled} handleSubmit={handleSubmit} />
    </div>
  );
}

export default LoginFormWrapper;
